import { useEffect, useRef } from 'react';

import { useLocaleNavigation } from '~/routes/hooks';
import {
  inferAppLocaleFromBrowserPreferences,
  persistLocalePreference,
  readLocalePreferenceFromCookie,
} from '~/utils/i18n';
import { resolveAppLocale } from '~/utils/locale-path';

export const LocalePreferenceBootstrap = () => {
  const { locale, setLocale } = useLocaleNavigation();
  const didResolveInitialPreference = useRef(false);
  const didSkipInitialSync = useRef(false);
  const currentLocale = resolveAppLocale(locale);

  useEffect(() => {
    if (didResolveInitialPreference.current) {
      return;
    }

    didResolveInitialPreference.current = true;

    const cookieLocale = readLocalePreferenceFromCookie(document.cookie);
    const browserLocale =
      inferAppLocaleFromBrowserPreferences(navigator.languages) ??
      inferAppLocaleFromBrowserPreferences(
        navigator.language ? [navigator.language] : undefined
      );
    const preferredLocale = cookieLocale ?? browserLocale;

    if (preferredLocale && preferredLocale !== currentLocale) {
      setLocale(preferredLocale);
      return;
    }

    persistLocalePreference(preferredLocale ?? currentLocale);
  }, [currentLocale, setLocale]);

  useEffect(() => {
    if (!didSkipInitialSync.current) {
      didSkipInitialSync.current = true;
      return;
    }

    persistLocalePreference(currentLocale);
  }, [currentLocale]);

  return null;
};
